import styled from 'styled-components';
import {
  Table,
  TableContainer,
  TableContainerProps
} from '@mui/material';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  > button {
    margin: 0 auto;
  }
`;

export const ContainerOrderNumber = styled.p`
  font-size: 0.9rem;
  margin: 0;
`;

export const LabelOrderNumber = styled.span`
  font-weight: bold;
  margin: 0 0.2rem 0 0;
`;

export const DetailSpan = styled.span`
  display: block;
`;

export const ContainerTabs = styled.div`
  width: 100%;
`;

export const ContainerReason = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1rem;
  margin-top: .5rem;
`;

export const LabelReason = styled.h6`
  color: ${({ theme }) => theme.red};
  font-size: .8rem;
`;

interface IStyledTableContainer extends TableContainerProps {
  $maxHeight?: string;
}
// prettier-ignore
export const StyledTableContainer = styled(TableContainer)<IStyledTableContainer>`
  &&& {
    width: 100%;
    max-height: ${({ $maxHeight }) => $maxHeight || '100%'};
    overflow-x: auto;
  }
`;

interface IStyledTable extends TableContainerProps {
  $sizeCell: 'small' | 'medium' | 'large';
  $typeGrid: 'oddEven' | 'default' | 'backgroundHeader' | 'backgroundBody';
}
export const StyledTable = styled(Table)<IStyledTable>`
  &&& {
    min-width: 760px;

    /* Styles size cell */
    ${props =>
      props.$sizeCell === 'small' &&
      ` .MuiTableCell-root {
      padding: 0 0 0 10px;

    }
    `}

    ${props =>
      props.$sizeCell === 'medium' &&
      `.MuiTableCell-root {
      padding: 5px 10px;
    }
  `}

  ${props =>
      props.$sizeCell === 'large' &&
      `.MuiTableCell-root {
      padding: 10px 16px;
    }
  `}

  /* Styles type grid */
  ${({ $typeGrid }) =>
      ($typeGrid === 'backgroundHeader' || $typeGrid === 'oddEven') &&
      `
    .MuiTableCell-head {
      background: #cccccc;
      color: #9e9e9e;
    }
  `}
  ${({ $typeGrid }) =>
      $typeGrid === 'oddEven' &&
      `
    .MuiTableRow-root:nth-child(even) {
      background-color: #fff;
    }

    .MuiTableRow-root:nth-child(odd) {
      background-color: #f2f2f2;
    }
  `}
  ${({ $typeGrid, theme }) =>
      $typeGrid === 'backgroundBody' &&
      `
    .MuiTableBody-root .MuiTableRow-root {
      background-color: ${theme.grayLight};
    }
  `}
  }
`;

export const TooltipText = styled.p`
  margin: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
  max-width: 300px;
`;